import { lazy, Suspense, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { Redirect, Route, Switch } from "react-router-dom";
import { useGlobalContext } from "../../context/globalContext";
import Steps from "../../shared/steps/steps";
import Loader from "../../shared/loaders/simpleLoader";
import { SERVICE_TYPES } from "../../utils/constants/fieldErrors";
import useServiceType from "../../hooks/useServiseType";
import { useLegalFormStepsContext } from "../../context/LegalFormContext";

const OrganizationInfo = lazy(() =>
  import("../../components/LegalForm/steps/organizationInfo")
);
const Agreement = lazy(() =>
  import("../../components/LegalForm/steps/agreement/agreement")
);
const Step2 = lazy(() => import("../../components/LegalForm/steps/step2"));
const Step3 = lazy(() =>
  import("../../components/LegalForm/steps/step3/step3")
);

const Step6 = lazy(() => import("../../components/LegalForm/steps/step6"));
const Step7 = lazy(() => import("../../components/LegalForm/steps/step7"));
const Step8 = lazy(() =>
  import("../../components/LegalForm/steps/step8/step8")
);

export function LegalFormStepRoutes() {
  const { steps, activeStep, setActiveStep } = useLegalFormStepsContext();
  const { i18n } = useTranslation();
  const { serviceType } = useServiceType();

  const {
    globalData: { status },
  } = useGlobalContext();
  const isApproved = useMemo(() => status !== "Approved", [status]);

  return (
    <Steps
      steps={steps}
      activeStep={activeStep}
      setActiveStep={setActiveStep}
      hideSteps={serviceType !== SERVICE_TYPES.Legal && true}
    >
      <Suspense fallback={<Loader />}>
        {isApproved ? (
          <Switch>
            <Route
              component={Agreement}
              path={`/Legal/agreement/:mobile?/${i18n.language}`}
            />
            <Route component={Step2} path={`/Legal/step/2`} />
            <Route
              component={Step3}
              path={`/Legal/Identomat/${i18n.language}`}
            />
            <Redirect to={`/Legal/agreement/${i18n.language}`} />
          </Switch>
        ) : (
          <Switch>
            <Route component={OrganizationInfo} path={`/Legal/step/4`} />
            <Route component={Step6} path={`/Legal/step/5`} />
            <Route component={Step7} path={`/Legal/step/6`} />
            <Route component={Step8} path={`/Legal/step/7`} />
            <Redirect to={`/Legal/step/4`} />
          </Switch>
        )}
      </Suspense>
    </Steps>
  );
}
